import { Image } from 'expo-image';
import { Text, YStack } from 'tamagui';

import PSLinkButton from '@/components/ui/PSLinkButton';
import { color } from '@/constants/tokens';

// A home section whose fetch SUCCEEDED with an empty list — nothing failed, so
// the affordance is a refresh rather than a retry.

// Height follows the source's own 677×369 ratio; capped rather than fixed so the
// art still fits inside the page's padding on a narrow phone.

export default function PSHomeSectionEmpty({
  onRefresh,
  isBackgroundDark = false,
}: {
  onRefresh: () => void;
  isBackgroundDark?: boolean;
}) {
  return (
    <YStack
      justify="center"
      items="center"
      gap="$space.lg"
      py="$space.xl"
      borderRadius={'$radius.base'}
      p={'$space.lg'}
    >
      <Image
        source={require('@/assets/images/no-data-cat.png')}
        style={{
          width: '100%',
          aspectRatio: 677 / 369,
        }}
        contentFit="contain"
        transition={200}
        tintColor={isBackgroundDark ? color.borderColor : color.brand}
      />
      <Text
        color={isBackgroundDark ? '$textWhite' : '$textDark'}
        textAlign="center"
      >
        No scenes to put right now.{' '}
        <PSLinkButton title="Refresh" onPress={onRefresh} />, in case something
        might have come up
      </Text>
    </YStack>
  );
}
